export enum paramTypes {
  string = "string",
  integer = "integer",
  number = "number",
  boolean = "boolean",
  array = "array",
  object = "object",
}

export type BaseParameter = {
  name: string;
  description: string;
  type: paramTypes;
  required?: boolean;
};
export type arrayParameter = BaseParameter & {
  type: paramTypes.array;
  items: [Parameter];
};
export type ObjectParameter = BaseParameter & {
  type: paramTypes.object;
  properties: Parameter[];
};

export type Parameter =
  | (BaseParameter & {
      type: Exclude<paramTypes, paramTypes.array | paramTypes.object>;
    })
  | arrayParameter
  | ObjectParameter;

export type schemaFormat = {
  type: paramTypes;
  description?: string;
  properties?: { [key: string]: schemaFormat };
  required?: string[];
  items?: schemaFormat;
};
